export const ROLE_HOME = {
  admin: '/dashboard',
  ict_manager: '/dashboard',
  dashboard_viewer: '/home',
  employee_manager: '/team-dashboard',
  project_manager: '/team-dashboard',
  delivery_manager: '/team-dashboard',
  jr_engineer: '/my-dashboard',
  sr_engineer: '/my-dashboard',
  employee: '/tickets'
};

export const ROLE_COLOR = {
  admin: 'error',
  ict_manager: 'warning',
  employee_manager: 'secondary',
  jr_engineer: 'info',
  sr_engineer: 'info',
  employee: 'success',
  dashboard_viewer: 'default'
};

export const ICT_MANAGEMENT_ROLES = ['admin', 'ict_manager'];
// Roles allowed to approve/reject at the IS-review / ICT-acceptance stage
// (e.g. requests raised by a manager who has no reporting Sr Manager).
export const IS_REVIEW_ROLES = ['sr_engineer', 'ict_manager', 'admin'];
export const BUSINESS_MANAGER_ROLES = ['employee_manager'];
export const MANAGEMENT_ROLES = [...ICT_MANAGEMENT_ROLES, ...BUSINESS_MANAGER_ROLES];
export const ENGINEERING_ROLES = ['jr_engineer', 'sr_engineer'];
export const ICT_TEAM_ROLES = [...ICT_MANAGEMENT_ROLES, ...ENGINEERING_ROLES];
export const TICKET_OPERATOR_ROLES = [...ICT_TEAM_ROLES, ...BUSINESS_MANAGER_ROLES];
export const STAFF_ROLES = [...ICT_TEAM_ROLES];
export const USER_MANAGEMENT_ROLES = ['admin'];
export const TEAM_DASHBOARD_ROLES = ['admin', 'employee_manager'];
export const ALL_ROLES = [...TICKET_OPERATOR_ROLES, 'employee'];

// ── HR-department gate (replaces the retired `hr` role) ──
// On-behalf asset returns are available to HR-department members plus the
// admin/ict_manager override. Mirrors backend utils/onBehalfSigners.js.
const HR_DEPT_NAMES = ['hr', 'human resources', 'human resource'];
export function isHrDepartmentUser(user) {
  if (!user) return false;
  if (['admin', 'ict_manager'].includes(user.role)) return true;
  const name = (user.department || '').trim().toLowerCase();
  if (name && HR_DEPT_NAMES.includes(name)) return true;
  // departmentId may be populated to an object carrying a stable `code`.
  const code = (user.departmentId?.code || '').toUpperCase();
  return code === 'HR';
}

// Register-As categories for user creation UI
export const REGISTER_AS = {
  office: ['employee', 'employee_manager'],
  ict:    ['jr_engineer', 'sr_engineer', 'ict_manager']
};

// Reports-To hierarchy
export const REPORTS_TO = {
  employee:         ['employee_manager'],
  employee_manager: ['employee_manager'],
  project_manager:  ['employee_manager'],
  delivery_manager: ['employee_manager'],
  jr_engineer:      ['ict_manager'],
  sr_engineer:      ['ict_manager'],
  ict_manager:      [],
  admin:            [],
  dashboard_viewer: []
};

// Roles where the reporting manager field is optional (shown via a checkbox)
export const OPTIONAL_MANAGER_ROLES = ['employee_manager', 'project_manager', 'delivery_manager'];
